import { supabase } from '../utils/supabaseClient';

interface PersonStats {
    person_id: number;
    person_goals: number;
    person_matches: number;
    person_yellow_cards: number;
    person_red_cards: number;
}

const fetchAllPersonStats = async (): Promise<PersonStats[]> => {
    try {
        console.log('Fetching all person stats...');

        // Step 1: Fetch data from all relevant tables
        const { data: goalsData, error: goalsError } = await supabase
            .from('player_goals')
            .select('id, count');

        if (goalsError) {
            throw goalsError;
        }

        const { data: matchesData, error: matchesError } = await supabase
            .from('player_matches')
            .select('id, count');

        if (matchesError) {
            throw matchesError;
        }

        const { data: yellowCardsData, error: yellowCardsError } = await supabase
            .from('player_yellow_cards')
            .select('id, count');

        if (yellowCardsError) {
            throw yellowCardsError;
        }

        const { data: redCardsData, error: redCardsError } = await supabase
            .from('player_red_cards')
            .select('id, count');

        if (redCardsError) {
            throw redCardsError;
        }

        // Step 2: Create a map to consolidate the data
        const statsMap: { [key: number]: PersonStats } = {};

        // Process goals data
        goalsData.forEach((goal: { id: number; count: number }) => {
            if (!statsMap[goal.id]) {
                statsMap[goal.id] = {
                    person_id: goal.id,
                    person_goals: 0,
                    person_matches: 0,
                    person_yellow_cards: 0,
                    person_red_cards: 0,
                };
            }
            statsMap[goal.id].person_goals = goal.count;
        });

        // Process matches data
        matchesData.forEach((match: { id: number; count: number }) => {
            if (!statsMap[match.id]) {
                statsMap[match.id] = {
                    person_id: match.id,
                    person_goals: 0,
                    person_matches: 0,
                    person_yellow_cards: 0,
                    person_red_cards: 0,
                };
            }
            statsMap[match.id].person_matches = match.count;
        });

        // Process yellow cards data
        yellowCardsData.forEach((card: { id: number; count: number }) => {
            if (!statsMap[card.id]) {
                statsMap[card.id] = {
                    person_id: card.id,
                    person_goals: 0,
                    person_matches: 0,
                    person_yellow_cards: 0,
                    person_red_cards: 0,
                };
            }
            statsMap[card.id].person_yellow_cards = card.count;
        });

        // Process red cards data
        redCardsData.forEach((card: { id: number; count: number }) => {
            if (!statsMap[card.id]) {
                statsMap[card.id] = {
                    person_id: card.id,
                    person_goals: 0,
                    person_matches: 0,
                    person_yellow_cards: 0,
                    person_red_cards: 0,
                };
            }
            statsMap[card.id].person_red_cards = card.count;
        });

        // Convert the map to an array
        return Object.values(statsMap);
    } catch (error) {
        console.error('Error fetching all person stats:', error);
        throw error;
    }
};

export default fetchAllPersonStats;
